import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoResults = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 21L14.8033 14.8033M14.8033 14.8033C16.1605 13.4461 17 11.5711 17 9.5C17 5.35786 13.6421 2 9.5 2C5.35786 2 2 5.35786 2 9.5C2 13.6421 5.35786 17 9.5 17C11.5711 17 13.4461 16.1605 14.8033 14.8033ZM7 12L12 7M7 7L12 12",
		stroke: "#EFEEF0",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNoResults;
